/**
 * TASK_52 — кое съобщение вижда родителят, когато PDF-ът на подписана декларация не се изтегли.
 *
 * Досега екранът показваше суровия английски текст на сървъра („Signature not found for this
 * assignment"). Сега — преведено съобщение по HTTP статуса; текстът на сървъра не стига до родителя.
 * „Няма право" (403) и „няма такова" (404) са различни неща и се казват различно.
 */
export type PdfDownloadErrorKey =
  | 'assignments.pdfForbidden'
  | 'assignments.pdfNotFound'
  | 'assignments.pdfDownloadError';

export function pdfDownloadErrorKey(status: number): PdfDownloadErrorKey {
  if (status === 403) return 'assignments.pdfForbidden';
  if (status === 404) return 'assignments.pdfNotFound';
  return 'assignments.pdfDownloadError';
}
